<template>
  <button class="tw-border-none tw-flex tw-items-center tw-px-1" :class="[buttonClasses]" @click="handleClick">
    <span class="tw-sr-only">Use setting</span>
    <span :class="[sliderClasses]" aria-hidden="true">
      <span :class="[sliderIconClasses]" aria-hidden="true">
        <svg v-if="!toggleOn" class="tw-h-3 tw-w-3 tw-text-gray-400" fill="none" viewBox="0 0 12 12">
          <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <svg v-else class="tw-h-3 tw-w-3 tw-text-blue-600" fill="currentColor" viewBox="0 0 12 12">
          <path
            d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
        </svg>
      </span>
    </span>
  </button>
</template>
  
<script>
export default {
  props: {
    toggleOn: {
      type: Boolean,
      default: false
    },
    enabledColor: {
      type: String,
      default: 'blue-600'
    },
    disabledColor: {
      type: String,
      default: 'gray-200'
    },
    onClick: {
      type: Function,
      default: null
    },
  },
  computed: {
    buttonClasses() {
      return [
        'tw-border-none tw-relative tw-inline-flex tw-h-10 tw-w-16 tw-flex-shrink-0 tw-cursor-pointer tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors tw-duration-200 tw-ease-in-out focus:tw-outline-none ',
        this.toggleOn ? `tw-bg-${this.enabledColor} tw-ring-2 tw-ring-blue-600 tw-ring-offset-2` : `tw-bg-${this.disabledColor} tw-ring-2 tw-ring-gray-600`
      ];
    },
    sliderClasses() {
      return [
        'tw-pointer-events-none tw-relative tw-inline-block tw-h-8 tw-w-8 tw-transform tw-rounded-full tw-bg-white tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out',
        this.toggleOn ? 'tw-translate-x-6' : 'tw-translate-x-0'
      ];
    },
    sliderIconClasses() {
      return [
        ' tw-absolute tw-inset-0 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-transition-opacity',
        this.toggleOn ? 'tw-opacity-100 tw-duration-200 ease-in' : 'tw-opacity-0 tw-duration-100 tw-ease-out'
      ];
    }
  },
  methods: {
    handleClick(event) {
      if (this.onClick) {
        this.onClick(event);
      }
    }
  }
};
</script>
  
<style scoped>
/* Add any scoped styles if needed */
</style>
  